import * as React from 'react';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {useEffect, useState} from "react";
import helpers from "../../helpers/common";
import useRootHook from "../../hooks/useRoot";
import EnhancedEncryptionIcon from '@mui/icons-material/EnhancedEncryption';
import {Add, Refresh, DeleteForever} from "@mui/icons-material";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import {Link as RouterLink} from "react-router-dom";
import servers from "../../models/servers";
import {Tooltip} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';
import TableToolbar from '../layout/TableToolbar';

export default function ServerIndex(props) {
    const [serversData, setServersData] = useState(null)
    const {setShowLoader, notify, showConfirm} = useRootHook()
    const [refreshId, setRefreshId] = useState(0)

    useEffect(() => {
        setShowLoader(true)
        servers.getServers()
            .then((data) => {
                data && setServersData(data)
                setShowLoader(false)
            }).catch(() => setShowLoader(false))
    }, [refreshId])

    const handleMakeSSL = async (serverName) => {
        const confirmed = await showConfirm('Please confirm you want to proceed', 'Generate SSL Certificate');
        if (!confirmed) {
            return
        }
        servers.makeSSL(serverName)
            .then(() => {
                notify('Request sent. Upon successful certificate generation a message will be sent in Telegram')
            })
    }

    const handleDelete = async (id) => {
        const confirmed = await showConfirm('Please confirm you want to delete the server', 'Delete Server');
        if (!confirmed) {
            return
        }
        servers.delete(id)
            .then(() => {
                notify('Server deleted')
                handleRefresh()
            })
    }
    const handleRefresh = () => {
        setRefreshId((prevId) => {
            return prevId + 1
        })
    }

    if (!serversData) return null

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader
                title="Servers"
                breadcrumbs={[['Dashboard', '/'], ['Servers', '/servers']]}
                actions={
                    <>
                        <Button to="/servers/add" component={RouterLink} variant="contained" startIcon={<Add />}>
                            Add server
                        </Button>
                        <Button onClick={handleRefresh} variant="outlined" startIcon={<Refresh />}>
                            Refresh
                        </Button>
                    </>
                }
            />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column', overflowX: 'auto'}}>
                <TableToolbar title="Servers" />
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Type & Location</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>IPs</TableCell>
                            <TableCell>Created</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {serversData.map((row) => (
                            <TableRow key={`customer-${row.id}`}>
                                <TableCell>
                                    <Link color="primary" to={`edit/?id=${row.id}`} component={RouterLink} server={row}>
                                        {row.id}
                                    </Link>
                                </TableCell>
                                <TableCell>{row.name}</TableCell>
                                <TableCell>{`${row.server_type.name} - ${row.datacenter.name} `}</TableCell>
                                <TableCell>{row.status}</TableCell>
                                <TableCell>{`${row.public_net.ipv4.ip} / ${row.public_net.ipv6.ip}`}</TableCell>
                                <TableCell>{helpers.getDate(row.created)}</TableCell>
                                <TableCell>
                                    <Tooltip title="Generate SSL certificate">
                                        <IconButton size="small" onClick={() => handleMakeSSL(row.name)}>
                                            <EnhancedEncryptionIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete server">
                                        <IconButton size="small" color="error" onClick={() => handleDelete(row.id)}>
                                            <DeleteForever fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </SectionCard>
        </Grid>
    </React.Fragment>
}

